componentRegistryInstance.register('map', 'read', 'hrd.components.form.MapComponent');

hrd.components.form.MapComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.MapComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		var geoOptions = $.evaluate(field.data('geoOptions')) || {};
		const geolocationMap = new hrd.GeolocationMap(field, geoOptions);
		field.data('map', geolocationMap);
	},
	getReadOnlyField: function(field, name, object, options) {
		/** @type hrd.GeolocationMap */
		const geolocationMap = field.data('map');
		if (geolocationMap != undefined) {
			const location = geolocationMap.getLocation();
			this.setValueByPath(object, name, location);
		}
	},
	setReadOnlyField: function(field, value, object, options) {
		/** @type hrd.GeolocationMap */
		const geolocationMap = field.data('map');
		geolocationMap.setLocation(value);
	},
	resetReadOnlyField: function(field, options) {
		/** @type hrd.GeolocationMap */
		const geolocationMap = field.data('map');
		geolocationMap.setLocation(null);
	}
});